// @flow
import { connect } from "react-redux";
import MessagesPageView from "./view";
import { sentMessage, fetchMessages } from "../state/messages/actions";

export default connect(
    state => ({
        messages: state.messages.all
    }),
    dispatch => ({
        onFetchMessages: () => dispatch(fetchMessages()),
        onSentMessage: message => dispatch(sentMessage(message))
    })
)(MessagesPageView);



// WEBPACK FOOTER //
// ./src/messages-page-view/index.js